import { FunctionResponseItem, FunctionResponseList } from '@/types/service-response'

export class EmployeeFunction {
  public constructor (
    readonly id: number,
    readonly name: string
  ) {}

  static createFromResponse (responseData: FunctionResponseList): Array<EmployeeFunction> {
    let result: Array<EmployeeFunction> = []
    if (responseData) {
      result = responseData.map((land: FunctionResponseItem ) => {
        return new EmployeeFunction(
          land.ID,
          land.Bezeichnung,
        )
      })
    }
    return result
  }
}
